module.exports = __webpack_public_path__ + "static/media/services-shape.958cbfc9.svg";